import React from 'react'
import { Box, Typography } from '@mui/material'
import { WallboxModel } from '../../wallboxes'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { getChargingCardLabel } from '../utils/get-charging-card-label'
import { ChargingCardModel } from '../api/models/charging-card-model'
import { useWallboxLabel } from 'src/Libs/e-mobility/shared/hooks/use-wallbox-label'

export interface LinkedWallboxesOverviewDialogProps {
  open: boolean
  onClose: () => void
  place: number
  linkedWallboxes: WallboxModel[]
  chargingCard: ChargingCardModel
}

/**
 * Dialog component that displays all wallboxes linked to a single charging card.
 * It displays an unordered list, with each lit item containing the wallbox name + wallbox id.
 *
 * @param linkedWallboxes - already linked wallboxes to a charging card
 * @param wallboxes - connected wallboxes to the installation
 * @param - all other params from ModalRoot
 */
export const LinkedWallboxesOverviewDialog: React.FC<LinkedWallboxesOverviewDialogProps> = ({
  linkedWallboxes,
  open,
  onClose,
  place,
  chargingCard,
}) => {
  const { t } = useCustomTranslation()

  const cardLabel = getChargingCardLabel({ rfid: chargingCard.tokenId, cardName: chargingCard.cardName, t })
  const { getWallboxLabel } = useWallboxLabel()

  return (
    <Dialog
      maxWidth="sm"
      title={t('emobility.charging-cards.linked-wallboxes-overview', { cardLabel })}
      onClose={onClose}
      place={place}
      actions={{
        secondary: {
          name: t('common.close'),
        },
      }}
    >
      <Box component="ul" sx={{ pt: 0, mt: 0, pl: 2 }}>
        {linkedWallboxes.map(wallbox => {
          const wallboxLabel = getWallboxLabel({ wallboxId: wallbox.wallboxId })

          return (
            <Box component="li" sx={{ mt: 2 }} key={wallbox.wallboxId}>
              <Typography variant="body1">{wallboxLabel}</Typography>
            </Box>
          )
        })}
      </Box>
    </Dialog>
  )
}
